<div class="footer-menu">
  <button class="back-button" (click)="emitGoBack()">
    <i class="fa fa-arrow-left" aria-hidden="true"></i>
  </button>

  <ul class="footer-icons">
    <li>
      <button (click)="goToTicket()" class="ticket-button">
        <span class="material-icons-outlined">confirmation_number</span>
        <span class="icon-label">Ticket</span>
      </button>
    </li>
  </ul>

  <button class="more-button" (click)="goToMenu()">
    <i class="fa fa-bars" aria-hidden="true"></i>
    <span class="icon-label">Menu</span>
  </button>
</div>
